import strings from "./Strings";
export const validateEmailAddress = (email: string): boolean => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(String(email).toLowerCase());
};
export const validateEmailAddressLoginPage = (email: string): boolean => {
const re = /^[a-zA-Z0-9._%+\s-]+@[a-zA-Z0-9.\s-]+\.[a-zA-Z]{2,}$/;
  return re.test(String(email).toLowerCase());
};
export const validatePassword = (password: string) => {
  if (!password.trim()) {
    return strings.validation.passwordError;
  }
  if (password.includes(" ")) {
    return strings.validation.passwordSpaceError;
  }
  // if (password.length < 8 || password.length > 16) {
  //   return strings.validation.passwordLengthError;
  // }
  return "";
};
export const validateRestPasswordPassword = (
  password: string,
  confirmPassword: string,
) => {
  if (password.includes(" ") || confirmPassword.includes(" ")) {
    return strings.validation.resetPasswordSpaceError;
  }
  if (
    password.length < 8 ||
    password.length > 16 ||
    !/[A-Z]/.test(password) || // Checks for at least one uppercase letter
    !/[a-z]/.test(password) || // Checks for at least one lowercase letter
    !/\d/.test(password) || // Checks for at least one digit
    !/[!@#$%^&*(),.?":{}|<>]/.test(password) // Checks for at least one special character
  ) {
    return strings.validation.resetPasswordLengthError;
  }
  if (password !== confirmPassword) {
    return "Password and confirm password does not match.";
  }
  return "";
};
